/* eslint-disable react/prop-types */
import React, { useState } from 'react'
import { Avatar, Autocomplete, TextField, Button, CircularProgress, Box, Typography, Tabs, Tab, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Collapse, InputAdornment } from '@mui/material'
import { Search, ExpandLess, ExpandMore, AcUnit, EmojiEvents, Star, History, Person, ArrowBackIosNew, ArrowForwardIos } from '@mui/icons-material'
import './utils.css'
import { DDRAGON_BASE_URL } from '../config.js'

export const TabPanel = (props) => {
  const { children, value, index, ...other } = props

  return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography component="div">{children}</Typography>
          </Box>
        )}
      </div>
  )
}

export const TabsPanel = ({ value, handleChange }) => {
  return (
    <Box sx={{ borderBottom: 0, borderColor: 'divider', display: 'flex', justifyContent: 'center' }}>
      <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" sx={{
        backgroundColor: '#49505e',
        color: '#ffffff',
        '& .MuiTabs-indicator': { backgroundColor: '#ffd54f' },
        '& .MuiTab-root': {
          textTransform: 'none',
          fontWeight: 'bold',
          '&:hover': { color: '#ffd54f', opacity: 1 },
          '&.Mui-selected': { color: '#bbdefb' }
        }
      }}>
        <Tab label="TFT" id="simple-tab-0" aria-controls="simple-tabpanel-0" />
        <Tab label="Aram" id="simple-tab-1" aria-controls="simple-tabpanel-1" />
        <Tab label="Aram God" id="simple-tab-2" aria-controls="simple-tabpanel-2" />
        <Tab label="Mastery Points" id="simple-tab-3" aria-controls="simple-tabpanel-3" />
      </Tabs>
    </Box>
  )
}

export const SideNav = ({ value, handleChange }) => {
  const [isTftOpen, setIsTftOpen] = useState(true)
  const [isLolOpen, setIsLolOpen] = useState(true)
  const [isCollapsed, setIsCollapsed] = useState(false)

  const tftTabs = [
    { label: 'Match History', index: 0, icon: <History fontSize="small" /> }
  ]

  const lolTabs = [
    { label: 'Aram', index: 1, icon: <AcUnit fontSize="small" /> },
    { label: 'Aram God', index: 2, icon: <EmojiEvents fontSize="small" /> },
    { label: 'Mastery Points', index: 3, icon: <Star fontSize="small" /> }
  ]

  const handleItemClick = (index) => {
    handleChange(null, index)
  }

  return (
    <aside className={`side-nav${isCollapsed ? ' side-nav--collapsed' : ''}`}>
      <div className="side-nav__scroll">
        <div className="side-nav__group">
        <div className="side-nav__group-header">
          <span className="side-nav__group-title">Teamfight Tactics</span>
          <button
            type="button"
            className="side-nav__group-toggle"
            onClick={() => setIsTftOpen((prev) => !prev)}
            aria-label="Toggle Teamfight Tactics section"
          >
            {isTftOpen ? <ExpandLess fontSize="medium" /> : <ExpandMore fontSize="medium" />}
          </button>
        </div>
        <Collapse in={isTftOpen} timeout={240} unmountOnExit>
          <List dense disablePadding className="side-nav__list">
            {tftTabs.map((tab) => (
              <ListItem key={tab.index} disablePadding>
                <ListItemButton
                  className={`side-nav__item${value === tab.index ? ' side-nav__item--active' : ''}`}
                  disableGutters
                  onClick={() => handleItemClick(tab.index)}
                >
                  <div className="side-nav__item-row">
                    <ListItemIcon className="side-nav__icon">{tab.icon}</ListItemIcon>
                    <ListItemText primary={tab.label} />
                  </div>
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Collapse>
      </div>

      <div className="side-nav__divider" />

      <div className="side-nav__group">
        <div className="side-nav__group-header">
          <span className="side-nav__group-title">League of Legends</span>
          <button
            type="button"
            className="side-nav__group-toggle"
            onClick={() => setIsLolOpen((prev) => !prev)}
            aria-label="Toggle League of Legends section"
          >
            {isLolOpen ? <ExpandLess fontSize="medium" /> : <ExpandMore fontSize="medium" />}
          </button>
        </div>
        <Collapse in={isLolOpen} timeout={240} unmountOnExit>
          <List dense disablePadding className="side-nav__list">
            {lolTabs.map((tab) => (
              <ListItem key={tab.index} disablePadding>
                <ListItemButton
                  className={`side-nav__item${value === tab.index ? ' side-nav__item--active' : ''}`}
                  disableGutters
                  onClick={() => handleItemClick(tab.index)}
                >
                  <div className="side-nav__item-row">
                    <ListItemIcon className="side-nav__icon">{tab.icon}</ListItemIcon>
                    <ListItemText primary={tab.label} />
                  </div>
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Collapse>
      </div>
      </div>

      <button
        type="button"
        className="side-nav__collapse"
        onClick={() => setIsCollapsed((prev) => !prev)}
        aria-label={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
      >
        {isCollapsed ? <ArrowForwardIos fontSize="small" /> : <ArrowBackIosNew fontSize="small" />}
      </button>
    </aside>
  )
}

export const sanitizeInput = (input) => {
  const exceptions = { 'Nunu & Willump': 'Nunu', 'Renata Glasc': 'Renata' }
  return exceptions[input] || input.replace(/[\s'.]/g, '')
}

export const SearchBar = ({ summonerName, region, searchHistory, setSummonerName, handleSearch, isLoading, setRegion }) => {
  const CustomSelect = ({ value, onChange }) => {
    const [isOpen, setIsOpen] = useState(false)
    const options = ['EUNE', 'EUW', 'NA', 'KR']

    const handleOptionClick = (option) => {
      onChange(option)
      setIsOpen(false)
    }

    return (
      <div className="custom-select-wrapper">
        <button
          type="button"
          className={`custom-select ${isOpen ? 'open' : ''}`}
          onClick={() => setIsOpen(!isOpen)}
          aria-haspopup="listbox"
          aria-expanded={isOpen}
          aria-label={`Selected region ${value}. Activate to change region`}
        >
          {value}
        </button>
        {isOpen && (
          <ul className="custom-options" role="listbox" aria-label="Region options">
            {options.map(option => (
              <li
                key={option}
                role="option"
                aria-selected={option === value}
              >
                <button
                  type="button"
                  className="custom-option"
                  onClick={() => handleOptionClick(option)}
                >
                  {option}
                </button>
              </li>
            ))}
          </ul>
        )}
        <select
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="hidden-select"
          aria-label="Select region"
        >
          {options.map(option => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
      </div>
    )
  }

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleSearch()
    }
  }

  const handleClick = (event) => {
    handleSearch()
  }

  const searchChange = (value, field) => {
    if (field === 'name') {
      setSummonerName(value)
    } else if (field === 'region') {
      setRegion(value)
    }
  }

  const getOptionLabel = (option, summonerName) => {
    if (!option) return ''
    if (option.playerName && option.hashTag) {
      return `${option.playerName}#${option.hashTag}`
    }
    return summonerName || ''
  }

  const filterOptions = (options, { inputValue }) => {
    const filtered = options.filter((option) =>
      option.playerName.toLowerCase().includes(inputValue.toLowerCase())
    )
    return filtered.slice(0, 4)
  }

  return (
    <div className="search-stack">
      <div className="search-card">
        <div className="input-group">
          <Autocomplete
            freeSolo
            sx={{ width: 'min(100%, 440px)', margin: 0 }}
            options={summonerName.length >= 2 ? searchHistory : []}
            filterOptions={filterOptions}
            getOptionLabel={(option) => getOptionLabel(option, summonerName)}
            onInputChange={(event, newInputValue) => {
              setSummonerName(newInputValue)
              searchChange(newInputValue, 'name')
            }}
            renderOption={(props, option) => {
              const { key, ...restProps } = props
              return (
              <Box component="li" key={option.id || option.profileIconId || option.playerName} {...restProps} sx={{ display: 'flex', alignItems: 'center', padding: '8px', gap: '10px', borderBottom: '1px solid #ccc' }}>
                <Avatar src={`${DDRAGON_BASE_URL}/img/profileicon/${option.profileIconId}.png`} />
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                  <span>{option.playerName}</span>
                  <span style={{ color: '#888', fontSize: '12px' }}>
                    #{option.hashTag} | Level {option.summonerLevel}
                  </span>
                </Box>
              </Box>
              )
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="e.g. G2 Celestial#EUNE"
                value={summonerName}
                onChange={(e) => searchChange(e.target.value, 'name')}
                onKeyPress={handleKeyPress}
                aria-label="Enter your summoner name"
                InputProps={{
                  ...params.InputProps,
                  startAdornment: (
                    <InputAdornment position="start">
                      <Person fontSize="small" />
                    </InputAdornment>
                  )
                }}
                sx={{
                  '& .MuiInputBase-root': {
                    borderRadius: '12px',
                    height: '42px',
                    padding: '6px 10px',
                    fontSize: '16px',
                    transition: 'box-shadow 0.2s ease',
                    textAlign: 'left',
                    backgroundColor: 'white',
                    display: 'flex',
                    flexWrap: 'nowrap',
                    alignItems: 'center'
                  },
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                      borderColor: 'rgba(0, 0, 0, 0.12)'
                    },
                    '&:hover fieldset': {
                      borderColor: 'rgba(0, 0, 0, 0.2)'
                    },
                    '&.Mui-focused fieldset': {
                      boxShadow: '0 0 0 2px rgba(91, 124, 250, 0.2)',
                      borderColor: '#5b7cfa'
                    }
                  }
                }}
              />
            )}
          />
          <CustomSelect value={region} onChange={setRegion} />
          <Button
            onClick={handleClick}
            aria-label={isLoading ? 'Searching summoner' : 'Search summoner'}
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: isLoading ? 'not-allowed' : 'pointer',
              backgroundColor: '#5b7cfa',
              boxShadow: '0 6px 16px rgba(91, 124, 250, 0.35)',
              color: '#ffffff',
              '&:hover': { backgroundColor: '#4a6cff' }
            }}
            disabled={!summonerName || isLoading}
            variant="contained"
            color="primary"
          >
            {isLoading ? (<CircularProgress size={24} sx={{ color: '#ffffff' }} />) : (<Search sx={{ color: '#ffffff' }} />)}
          </Button>
        </div>
        <div className="search-cue" />
      </div>
    </div>
  )
}
